<template>
  <v-card outlined class="pa-2">
    <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
      <v-col cols="12" class="py-0">
        <v-row class="align-center">
          <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['country'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.country}}</div>
          </v-col>
          <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n["customer_name"]}} </div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.name}}</div>
          </v-col>
          <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['address'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.address}}</div>
          </v-col>
          <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{i18n['city']}}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.city}}</div>
          </v-col>
          <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['phone_number'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.phone_number_1}}
              <v-btn 
                v-clipboard:copy="item.phone_number_1"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                color="success" 
                x-small 
                icon>
                <v-icon size="10">content_copy</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['alternative_phone'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.phone_number_2}}
              <v-btn 
                v-clipboard:copy="item.phone_number_2"
                v-clipboard:success="clipboardSuccessHandler"
                v-clipboard:error="clipboardErrorHandler"
                color="success" 
                x-small 
                icon>
                <v-icon size="10">content_copy</v-icon>
              </v-btn>
            </div>
          </v-col>
          <v-col cols="6" md="6">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['notes'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.note}}</div>
          </v-col>
        </v-row>
        <v-col cols="6" md="3">
            <div :class="`${arabic?'arFont':'enFont'}`" style="font-size:11px;font-weight:bold;">{{ i18n['business_name'] }}</div>
            <div :class="`${arabic?'arFont':'enFont'}`">{{item.business_name}}</div>
          </v-col>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
          <v-col cols="12" class="py-0">
            <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                {{  i18n["the_product"] }}
              </v-col>
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                {{ i18n['quantity'] }}
              </v-col>
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'}`" style="font-weight:bold;font-size:11px;">
                {{ i18n["unite_sold_price"] }}
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" class="py-0" v-for="(product, p) in item.order" :key="'product-'+p">
            <v-row class="align-center" :class="`${arabic?'arFont':'enFont'}`">
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'} py-0`">
                {{product.sku}}
              </v-col>
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'} py-0`">
                {{product.quantity}}
              </v-col>
              <v-col cols="4" :class="`${arabic?'arFont':'enFont'} py-0`">
                {{product.sold_price}}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="py-0">
        <v-row class="align-center">
          <v-col cols="6">
            <v-btn color="error" outlined block small :class="`${arabic?'arFont':'enFont'}`" @click="remove(i)">{{ i18n['remove_order_from_import'] }}</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" outlined block small :class="`${arabic?'arFont':'enFont'}`" @click="details(i)">{{ i18n["order_details_import"] }}</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>

</template>

<script>
import { format, render, cancel, register } from 'timeago.js';
export default {
  props:['embed', 'item', 'i'],
  data(){
    return {
      dialog:true,
    }
  },
  methods:{
    clipboardSuccessHandler ({ value, event }){
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    clipboardErrorHandler ({ value, event }) {
      this.$emit('clipboardSuccessHandler', { value, event })
    },
    getFormat(d){
      return format(d)
    },
    details(i) {
      this.$emit('details', i)
    },
    remove(i) {
      this.$emit('remove', i)
    },
    message(i) {
      this.$emit('message', i)
    },
  },
  computed:{
    statuses_obj(){
      // console.log(this.$store.state.statuses_obj)
      return this.$store.state.statuses_obj
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    users(){
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x=>{
        if(!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site(){
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin(){
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language(){
      return this.$store.state.language
    },
    globalLoading(){
      return this.$store.state.globalLoading
    },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    routeTitle(){
      let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
      if(main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if(sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles(){
      return this.$store.state.userRoles
    },
    notifications(){
      return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    },
  },
}
</script>

<style>

</style>